module.exports = __webpack_public_path__ + "static/media/Kitchen Chair.38faf362.jpg";